import {
  IFFFChangeHandlerEvent,
  IFieldState,
  IListFieldState,
  IRecurlyFieldState,
} from '../../../../interfaces';

const useListFieldState = (
  fieldStatus: Array<IFieldState | IRecurlyFieldState>
): IListFieldState => {
  let errorMsg = '';
  fieldStatus.forEach((field) => {
    errorMsg = `${errorMsg} ${field.errorMsg}`;
  });
  errorMsg = errorMsg.trim();

  let isTouched = false;
  fieldStatus.forEach((field) => {
    isTouched = isTouched || field.isTouched;
  });

  const changeHandler = (event: IFFFChangeHandlerEvent) => ({});

  const blurHandler = () => ({});

  function isFieldAbleToReset(field: IFieldState | IRecurlyFieldState): field is IFieldState {
    return (field as IFieldState).reset !== undefined;
  }

  const reset = () => {
    fieldStatus.forEach((field) => {
      if (isFieldAbleToReset(field)) {
        field.reset();
      }
    });
  };

  return {
    errorMsg,
    hasError: errorMsg !== '' && isTouched,
    isTouched,
    changeHandler,
    blurHandler,
    reset,
  };
};

export default useListFieldState;
